/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlEntityRelationStatsGroupResult } from './ControlEntityRelationStatsGroupResult';
import {
    ControlEntityRelationStatsGroupResultFromJSON,
    ControlEntityRelationStatsGroupResultFromJSONTyped,
    ControlEntityRelationStatsGroupResultToJSON,
} from './ControlEntityRelationStatsGroupResult';

/**
 * 
 * @export
 * @interface ControlEntityRelationStatsGroups
 */
export interface ControlEntityRelationStatsGroups {
    /**
     * 
     * @type {string}
     * @memberof ControlEntityRelationStatsGroups
     */
    assets?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityRelationStatsGroups
     */
    risk_score?: string;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityRelationStatsGroups
     */
    total?: number;
    /**
     * 
     * @type {Array<ControlEntityRelationStatsGroupResult>}
     * @memberof ControlEntityRelationStatsGroups
     */
    results?: Array<ControlEntityRelationStatsGroupResult>;
}

/**
 * Check if a given object implements the ControlEntityRelationStatsGroups interface.
 */
export function instanceOfControlEntityRelationStatsGroups(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlEntityRelationStatsGroupsFromJSON(json: any): ControlEntityRelationStatsGroups {
    return ControlEntityRelationStatsGroupsFromJSONTyped(json, false);
}

export function ControlEntityRelationStatsGroupsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityRelationStatsGroups {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'assets': !exists(json, 'assets') ? undefined : json['assets'],
        'risk_score': !exists(json, 'risk_score') ? undefined : json['risk_score'],
        'total': !exists(json, 'total') ? undefined : json['total'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(ControlEntityRelationStatsGroupResultFromJSON)),
    };
}

export function ControlEntityRelationStatsGroupsToJSON(value?: ControlEntityRelationStatsGroups | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'assets': value.assets,
        'risk_score': value.risk_score,
        'total': value.total,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(ControlEntityRelationStatsGroupResultToJSON)),
    };
}

